import { httpClient } from '@bcba/client-auth';
import { ExplorerUserProfileSerializer } from '@bcba/serializers';
import { basePathUsers } from '.';
import { UpdateUserProfileDto } from './dto';

export const putUserProfile = async (
  dto: UpdateUserProfileDto,
): Promise<ExplorerUserProfileSerializer> => {
  const { data } = await httpClient.put<ExplorerUserProfileSerializer>(
    `${basePathUsers}/update-profile`,
    dto,
  );

  return data;
};
